
const PersonIcon = () => {
    return (
        <svg width="45" height="50" viewBox="0 0 45 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.5534 0.248046C29.6522 0.248046 35.4268 6.00223 35.4268 13.0759C35.4268 20.1496 29.6522 25.9038 22.5534 25.9038C15.4546 25.9038 9.67999 20.1496 9.67999 13.0759C9.67999 6.00223 15.4546 0.248045 22.5534 0.248046Z" fill="#F579A0"/>
            <path d="M5.82739 33.5301C9.51119 29.6977 14.3897 27.5822 19.567 27.5822L25.5407 27.5822C30.7179 27.5822 35.5965 29.6977 39.2803 33.5301C42.3169 36.6982 44.2185 40.7146 44.7761 45.0375C45.0748 47.3574 43.4519 49.248 41.1719 49.248L3.9158 49.248C1.63583 49.248 0.0129682 47.3574 0.311652 45.0375C0.879157 40.7146 2.7808 36.6982 5.82739 33.5301Z" fill="#F579A0"/>
        </svg>
        
    )
}

export default PersonIcon;

